import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FilterSelect from '../../components/FilterSelect';
import * as catalogueActions from '../../actions/catalogue';
import {
    catalogueStateKey,
    isHorseNameFilterDisabled,
    isCommonFilterDisabled,
} from '../../helpers/catalogueUtils';

class HorseFilters extends PureComponent {
    isHorseNameFilterDisabled() {
        return isHorseNameFilterDisabled(this.props.refinement);
    }
    isCommonFilterDisabled() {
        return isCommonFilterDisabled(this.props.refinement);
    }
    render() {
        const {
            refinement: {
                horseName,
                horseSex,
                horseAge,
            },
            data: {
                horseNameOptions,
                horseSexOptions,
                horseAgeOptions,
            },
            loadHorseNameOptions,
            applyCatalogueHorseNameFilter,
            loadHorseSexOptions,
            applyCatalogueHorseSexFilter,
            loadHorseAgeOptions,
            applyCatalogueHorseAgeFilter,
        } = this.props;
        return (
            <div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Sex</span>
                    <FilterSelect
                        title="Sex"
                        disabled={this.isCommonFilterDisabled()}
                        value={horseSex}
                        options={horseSexOptions}
                        onPopoverDidOpen={loadHorseSexOptions}
                        onChange={applyCatalogueHorseSexFilter}
                    />
                </div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Age</span>
                    <FilterSelect
                        title="Age"
                        disabled={this.isCommonFilterDisabled()}
                        value={horseAge}
                        options={horseAgeOptions}
                        optionsSorter="value"
                        onPopoverDidOpen={loadHorseAgeOptions}
                        onChange={applyCatalogueHorseAgeFilter}
                    />
                </div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Name</span>
                    <FilterSelect
                        title="Name"
                        alphabet
                        showSearch
                        disabled={this.isHorseNameFilterDisabled()}
                        value={horseName}
                        options={horseNameOptions}
                        onPopoverDidOpen={loadHorseNameOptions}
                        onChange={applyCatalogueHorseNameFilter}
                    />
                </div>
            </div>
        );
    }
}

HorseFilters.propTypes = {
    refinement: PropTypes.shape({
        horseName: PropTypes.string,
        horseSex: PropTypes.string,
        horseAge: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    }).isRequired,

    data: PropTypes.shape({
        horseNameOptions: PropTypes.array.isRequired,
        horseSexOptions: PropTypes.array.isRequired,
        horseAgeOptions: PropTypes.array.isRequired,
    }),

    // Name
    loadHorseNameOptions: PropTypes.func.isRequired,
    applyCatalogueHorseNameFilter: PropTypes.func.isRequired,

    // Sex
    loadHorseSexOptions: PropTypes.func.isRequired,
    applyCatalogueHorseSexFilter: PropTypes.func.isRequired,

    // Age
    loadHorseAgeOptions: PropTypes.func.isRequired,
    applyCatalogueHorseAgeFilter: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    const { refinement, data } = state[catalogueStateKey];
    return { refinement, data };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(catalogueActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(HorseFilters);



// WEBPACK FOOTER //
// ./src/js/containers/Catalogue/HorseFilters.js